import { render, staticRenderFns } from "./IresaStopSale.vue?vue&type=template&id=05b11ec5&scoped=true"
import script from "./IresaStopSale.vue?vue&type=script&lang=js"
export * from "./IresaStopSale.vue?vue&type=script&lang=js"
import style0 from "./IresaStopSale.vue?vue&type=style&index=0&id=05b11ec5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b11ec5",
  null
  
)

export default component.exports